
export default function Social() {
  const socialLinks = [
    { name: '블로그', icon: 'ri-article-line', url: 'https://blog.naver.com/kildelee' },
    { name: '유튜브', icon: 'ri-youtube-line', url: 'https://www.youtube.com/@%EB%AA%A8%EB%9E%98%EC%9A%94%EC%A0%95K%EC%8A%A4%ED%83%80%EC%83%8C%EB%93%9C' },
    { name: '인스타그램', icon: 'ri-instagram-line', url: '#' },
  ];

  return (
    <section id="social" className="py-24 lg:py-32 bg-white border-t border-lineGray">
      <div className="max-w-6xl mx-auto px-6 lg:px-12">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8">
          <p className="text-sm text-textGray font-light">
            다양한 채널에서 소식을 만나보세요
          </p>
          
          <div className="flex items-center gap-8">
            {socialLinks.map((social, index) => (
              <a
                key={index}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                className="group flex items-center gap-3 cursor-pointer"
              >
                <div className="w-12 h-12 flex items-center justify-center border border-lineGray group-hover:border-black transition-colors">
                  <i className={`${social.icon} text-xl text-black`}></i>
                </div>
                <span className="text-sm font-light text-black hidden lg:block">{social.name}</span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
